import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../shared/contexts/auth/AuthContext';
import { useAccount } from '../../shared/contexts/account/AccountContexts';
import { SUPPORT_EMAIL } from '../../shared/constans/constans';
import { format } from 'date-fns';
import ImpersonationBanner from '../../shared/components/impersonation-banner/ImpersonationBanner';
import './BannedPage.scss';

/** Full-screen stop for a banned account: no menu, no navigation — only the message and a logout. */
const BannedPage: React.FC = () => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const { accountResponse } = useAccount();
  // Automatic ban (dangerous markup typed into a question/name) says why; the admin ban stays vague.
  const isAbuseBan = accountResponse?.banReason === 'ABUSE';
  const until = accountResponse?.bannedUntil
    ? format(new Date(accountResponse.bannedUntil), 'yyyy-MM-dd HH:mm')
    : null;

  return (
    <div className="banned-page">
      {/* No Layout here, so the admin's "Return to admin" bar has to be mounted by hand — otherwise a
          superadmin inspecting a banned account through "Login as user" has only the logout button. */}
      <ImpersonationBanner />
      <div className="banned-page__content">
        <h1 className="banned-page__title">
          {t(isAbuseBan ? 'accountBlockedAbuseTitle' : 'accountBannedTitle')}
        </h1>
        <div className="banned-page__description">
          {isAbuseBan
            ? until
              ? t('accountBlockedAbuseUntilDescription', { until })
              : t('accountBlockedAbuseDescription')
            : t('accountBannedDescription')}{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="banned-page__link">
            {SUPPORT_EMAIL}
          </a>
          .
        </div>
        <button className="banned-page__button" type="button" onClick={logout}>
          {t('logout')}
        </button>
      </div>
    </div>
  );
};

export default BannedPage;
